import type { ReactNode } from 'react';

export const symbol_mobile_info: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M260-40q-24.75 0-42.37-17.63Q200-75.25 200-100v-760q0-24 18-42t42-18h438q24.75 0 42.38 17.62Q758-884.75 758-860v150q18 3 30 16.95 12 13.96 12 31.63V-587q0 19-12 33t-30 17v437q0 24.75-17.62 42.37Q722.75-40 698-40H260Zm0-60h438v-760H260v760Zm0 0v-760 760Zm241.5-206.63q8.5-8.62 8.5-21.37v-196q0-12.75-8.68-21.38-8.67-8.62-21.5-8.62-12.82 0-21.32 8.62-8.5 8.63-8.5 21.38v196q0 12.75 8.68 21.37 8.67 8.63 21.5 8.63 12.82 0 21.32-8.63Zm2-300.85q9.5-9.48 9.5-23.5t-10-23.52q-10-9.5-24-9.5t-23 9.48q-9 9.48-9 23.5t9.48 23.52q9.48 9.5 23.5 9.5t23.52-9.48Z"
		/>
	</svg>
);
